import { MY_NOTES, MY_OFFICES, SET_FIELDS, SET_TAG_SETTING, USER_CONTACT } from '../constants';
import { TypedCacheBucket } from '../models/state.models';

export class SetFields {
  readonly type = SET_FIELDS;
  constructor(public readonly payload?: { data: unknown | null }) {}
}

export class SetTagSetting {
  readonly type = SET_TAG_SETTING;
  constructor(public readonly payload?: { data: TypedCacheBucket | null }) {}
}

export class SetMyOffices {
  readonly type = MY_OFFICES;
  constructor(public readonly payload?: { data: unknown | null }) {}
}

/** @deprecated Use SetMyOffices */
export class SetMyOffieces extends SetMyOffices {}

export class SetMyNotes {
  readonly type = MY_NOTES;
  constructor(public readonly payload?: { data: unknown | null }) {}
}

export class SetContact {
  readonly type = USER_CONTACT;
  constructor(public readonly payload?: { data: TypedCacheBucket | null }) {}
}
